export default __webpack_public_path__ + "static/media/111.c8e1b237.png";